import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonaCardComponent } from '../../_components/persona-card/persona-card.component';
import { AlumnoChipComponent } from './alumno-chip/alumno-chip.component';
import { GLMMaterialDesignModule } from 'src/app/_components/material-design/material-design.module';


@NgModule({
  declarations: [PersonaCardComponent, AlumnoChipComponent],
  imports: [
    CommonModule,
    GLMMaterialDesignModule
  ],
  exports: [PersonaCardComponent, AlumnoChipComponent]
})
export class PersonaCardModule {}
